var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pay-here-content" }, [
    _c("h2", [_vm._v("Check-in")]),
    _c(
      "div",
      { staticClass: "steps-module-content" },
      [_c("StepsBar", { attrs: { steps: _vm.steps } })],
      1
    ),
    _c(
      "div",
      { staticClass: "step-view" },
      [
        _c("router-view", {
          on: {
            enableNextButton: function ($event) {
              _vm.enableNextButton = $event
            },
            enableBackButton: function ($event) {
              _vm.enableBackButton = $event
            },
            sendNameNextStep: _vm.setNextStepName,
            sendNameBackStep: _vm.setBackStepName,
            "set-event-next": _vm.setEventNext,
            showModal: function ($event) {
              _vm.isModalActive = true
            },
            hideModal: function ($event) {
              _vm.isModalActive = false
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }